module.exports = __webpack_public_path__ + "static/media/blog-hero.939d78a0.png";